module.exports = __webpack_public_path__ + "img/card-guideline-left.ec30cf72.svg";